<template>
  <v-form>
    <validation-observer ref="observer" v-slot="{invalid, reset, handleSubmit}">
      <v-card>
        <v-card-title>{{model.id ? 'Изменить ед измерения' : 'Создать ед измерения'}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{errors}" name="name" rules="required|max:256">
                <v-text-field v-model="model.name"
                              required :error-messages="errors"
                              label="Наименование"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider v-slot="{errors}" name="full_name" rules="required|max:256">
                <v-text-field v-model="model.full_name"
                              required :error-messages="errors"
                              label="Название"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider v-slot="{errors}" name="code" rules="required|integer">
                <v-text-field v-model="model.code"
                              required :error-messages="errors"
                              label="Код"
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-space-between pb-4 px-4">
          <v-btn @click="handleSubmit(save)"
                 :loading="!!saving"
                 :disabled="!!saving || invalid"
                 rounded color="success"
          ><v-icon left>mdi-content-save</v-icon> {{model.id ? 'Сохранить' : 'Создать'}}</v-btn>
          <v-btn @click="cancel(reset)"
                 :disabled="!!saving"
                 :loading="!!saving"
                 rounded text color="error"
          ><v-icon left>mdi-cancel</v-icon> Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-form>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'measurement-form',

    computed: {
      ...mapState('Measurement', ['saving', 'model']),
    },

    methods: {
      cancel(reset) {
        reset()
        this.$emit('measurement:form:cancel')
      },

      save() {
        this.$store
          .dispatch('Measurement/save')
          .then(() => {
            this.$emit('measurement:form:saved')
          })
      },
    },
  }
</script>
